<template>
  <div class="profile-dropdown flex-center">
    <span class="profile-dropdown__avatar-container">
      <slot name="avatar" />
    </span>
    <span class="profile-dropdown__username" v-if="accountName">
      {{ accountName }}
      <i
        class="glyphicon glyphicon-triangle-bottom"
        v-if="currentUser && currentUser.tenantList.length > 1"
      ></i>
    </span>
    <vuestic-dropdown v-model="isShown" position="bottom" v-if="currentUser">
      <!-- <div class="dropdown-item plain-link-item" v-if="currentUser">
        {{ currentUser.email }}
      </div> -->
      <div v-for="option in currentUser.tenantList" :key="option.id">
        <div
          v-if="option.name !== accountName"
          class="dropdown-item account-dropdown-item plain-link-item"
          @click="setAccount(option)"
        >
          {{ option.name }}
        </div>
      </div>
    </vuestic-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'profile-section',
  data() {
    return {
      isShown: false
    }
  },
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'currentAccount']),
    accountName() {
      let account = JSON.parse(localStorage.getItem('account'))
      if (!this.currentAccount && account !== null) {
        this.$store.commit('setCurrentAccount', account)
        return account.name
      } else if (this.currentAccount) {
        return this.currentAccount.name
      } else {
        return ''
      }
    }
  },
  methods: {
    ...mapActions(['fetchCurrentUser']),
    setAccount(account) {
      this.$store.commit('setCurrentAccount', account)
    },
    logout() {
      this.$store.dispatch('logout')
    }
  },
  created() {
    if (!this.currentUser) {
      this.fetchCurrentUser()
    }
  }
}
</script>

<style lang="scss">
@import '../../../../../vuestic-theme/vuestic-sass/resources/resources';

.profile-dropdown {
  cursor: pointer;
  &__avatar-container {
    display: inline-block;
    width: 40px;
    height: 40px;
    background-color: white;
    border-radius: 50%;
    border: 2px solid $lighter-gray;
    overflow: hidden;
    transition: border-color 0.1s ease-in;
    img {
      height: 100%;
      width: 100%;
    }
  }
  &__username {
    color: $white;
    margin-left: 10px;
    text-transform: uppercase;
    transition: color 0.1s ease-in;
    .glyphicon {
      font-size: 15px;
    }
  }
  &:hover {
    .profile-dropdown__username {
      color: lighten($blue, 10%);
    }
    .profile-dropdown__avatar-container {
      border-color: lighten($blue, 10%);
    }
  }
}
.account-dropdown-item:hover {
  background-color: lighten($darkblue, 10%) !important;
  cursor: pointer !important;
}
</style>
